export class SapCourtesyControls {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sourceTimeZone",
            "baseName": "sourceTimeZone",
            "type": "string",
            "format": ""
        },
        {
            "name": "maintenanceEnabled",
            "baseName": "maintenanceEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "maintenanceWeekdays",
            "baseName": "maintenanceWeekdays",
            "type": "Array<number>",
            "format": ""
        },
        {
            "name": "maintenanceStartHour",
            "baseName": "maintenanceStartHour",
            "type": "number",
            "format": ""
        },
        {
            "name": "maintenanceEndHour",
            "baseName": "maintenanceEndHour",
            "type": "number",
            "format": ""
        },
        {
            "name": "businessHoursEnabled",
            "baseName": "businessHoursEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "businessHoursWeekdays",
            "baseName": "businessHoursWeekdays",
            "type": "Array<number>",
            "format": ""
        },
        {
            "name": "businessHoursStartHour",
            "baseName": "businessHoursStartHour",
            "type": "number",
            "format": ""
        },
        {
            "name": "businessHoursEndHour",
            "baseName": "businessHoursEndHour",
            "type": "number",
            "format": ""
        },
        {
            "name": "businessHoursThroughputPct",
            "baseName": "businessHoursThroughputPct",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxDialogWorkProcesses",
            "baseName": "maxDialogWorkProcesses",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxBatchWorkProcesses",
            "baseName": "maxBatchWorkProcesses",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SapCourtesyControls.attributeTypeMap;
    }
    constructor() {
    }
}
